<template>
  <div class="col-12 col-sm-6 col-md-4 project">
    <a :style="{backgroundImage: backgroundImage}" @click="showDetails(project)">
      <div class="description">
        <div class="container" :id="project.id">
          <p class="title">{{ project.content.title }}</p>
          <p>{{ project.content.description }}</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    project: Object
  },
  data: function() {
    let masterImage = this.project.images.filter(
      image => image.master === true
    )[0];
    return {
      backgroundImage:
        "url('" +
        process.env.BASE_URL +
        "img/products/" +
        masterImage.url +
        "')"
    };
  },
  methods: {
    showDetails: function(project) {
      this.$emit("opened", project);
    }
  }
};
</script>

<style>
</style>
